import React from 'react';
import Footer from './Footer'; // Adjust the path as needed

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Optional Header here */}
      
      {/* Main content area */}
      <main className="flex-1">
        {children}
      </main>

      {/* Footer sticks to the bottom */}
      <Footer />
    </div>
  );
};

export default Layout;
